import { createStore } from 'vuex'

export default createStore({
  state: {
    headers: null,
    companyRfc: null,
  },
  getters: {
    headers(state) {
      return state.headers
    },
    companyRfc(state) {
      return state.companyRfc
    },
  },
  mutations: {
    SET_HEADERS(state) {
      if(window.hostname == 'facturas.grupo-gemsa.com.mx') {
        state.headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${process.env.VUE_APP_API_TOKEN}`
        }
      }
      if(window.hostname == 'facturas-dulccinea.grupo-gemsa.com.mx') {
        state.headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${process.env.VUE_APP_API_DULCCINEA}`
        }
      }
      if(window.hostname == 'facturas-reyplas.grupo-gemsa.com.mx') {
        state.headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${process.env.VUE_APP_API_REYPLAS}`
        }
      }
      if(window.hostname == 'facturaselpescadito.esaky.mx') {
        state.headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${process.env.VUE_APP_API_PESCADITO}`
        }
      }
      if(window.hostname == 'porcelana.esaky.mx') {
        state.headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${process.env.VUE_APP_API_PORCELANA}`
        }
      }
    },
    SET_COMPANY_RFC(state, rfc) {
      state.companyRfc = rfc
    }
  },
  actions: {
    setCompanyRfc({ commit }, rfc) {
      commit('SET_COMPANY_RFC', rfc)
    }
  },
  modules: {
  }
})
